<script setup>

import {useUserTreatmentSessionStore} from "@/stores/userTreatmentSession.store";
import {storeToRefs} from "pinia";
import {onMounted} from "vue";
import {useGlobalStore} from "@/stores/global.store";

const globalStore = useGlobalStore();
const userTreatmentSessionStore = useUserTreatmentSessionStore();
const {userTreatmentSessions, name, status} = storeToRefs(userTreatmentSessionStore);


onMounted(async () => {
    globalStore.loading = true;
    userTreatmentSessionStore.reset();
    await userTreatmentSessionStore.fetchAll();
    globalStore.loading = false;
});

const search = async () => {
    globalStore.loading = true;
    await userTreatmentSessionStore.fetchAll();
    globalStore.loading = false;
}

const updateStatus = async (statusInput) => {
    globalStore.loading = true;
    userTreatmentSessionStore.status = statusInput;
    if (statusInput === '') {
        userTreatmentSessionStore.name = '';
    }
    await userTreatmentSessionStore.fetchAll();
    globalStore.loading = false;
}

</script>

<template>
  <van-space direction="vertical" fill>
    <van-search v-model="name" @search="search" @cancel="search" placeholder="Search for your sessions"/>
    <van-grid clickable :column-num="4">
      <van-grid-item icon="filter-o" text="All" :dot="status === ''" @click="updateStatus('')"/>
      <van-grid-item icon="todo-list-o" text="Not Started" :dot="status === 'Not Started'"
                     @click="updateStatus('Not Started')"/>
      <van-grid-item icon="underway-o" text="Awaiting" :dot="status === 'Awaiting Approval'"
                     @click="updateStatus('Awaiting Approval')"/>
      <van-grid-item icon="passed" text="Completed" :dot="status === 'Completed'" @click="updateStatus('Completed')"/>
    </van-grid>

    <div v-if="userTreatmentSessions.length === 0">
      <van-empty image="search" description="Nothing found"/>
    </div>
    <div v-if="userTreatmentSessions.length > 0">
      <van-cell-group inset
                      v-for="userTreatmentSession in userTreatmentSessions" :key="userTreatmentSession.id">
        <van-cell is-link :to="'/session/' + userTreatmentSession.id" title="Session"
                  :value="userTreatmentSession.treatment_session.name"/>
        <van-cell v-if="userTreatmentSession?.user_treatment_plan?.treatment_plan?.name" title="Plan" :value="userTreatmentSession?.user_treatment_plan?.treatment_plan?.name"/>
        <van-cell title="Status" title-class="" :value="userTreatmentSession.status"/>
        <van-cell title="Scheduled" :value="userTreatmentSession.schedule_at_formatted"/>
        <van-cell title="Created" :value="userTreatmentSession.created_at_formatted"/>
        <van-cell title="Counselor" v-if="userTreatmentSession.staff_user">
          <template #label>
            {{ userTreatmentSession.staff_user }}
          </template>
        </van-cell>
        <van-row>&nbsp;</van-row>
      </van-cell-group>
    </div>
  </van-space>
</template>
